import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI } from '@/utils/api';

/**
 * Connexion en 1 clic (magic link) depuis un email.
 * Échange le token signé (?token=) contre une session, puis redirige vers ?next=.
 * En cas de token expiré/invalide, bascule sur la connexion classique en
 * conservant la destination (l'utilisateur n'est jamais bloqué).
 */
const MagicPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    const next = searchParams.get('next') || '/dashboard';

    if (!token) {
      navigate(`/login?redirect=${encodeURIComponent(next)}`, { replace: true });
      return;
    }

    authAPI
      .magic(token)
      .then((res) => {
        localStorage.setItem('token', res.data.access_token);
        localStorage.setItem('user', JSON.stringify(res.data.user));
        navigate(next, { replace: true });
      })
      .catch(() => {
        navigate(`/login?redirect=${encodeURIComponent(next)}`, { replace: true });
      });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#f8fafc' }}>
      <div className="text-center">
        <div className="loader mx-auto mb-6"></div>
        <h2 className="text-xl font-semibold" style={{ color: '#1e3a8a' }}>
          Connexion en cours…
        </h2>
        <p className="text-gray-600 mt-2">Accès à votre analyse dans un instant.</p>
      </div>
    </div>
  );
};

export default MagicPage;
